import { ActionAuthorizePage } from "@redotech/redo-customer-portal-app/action-authorize/action-authorize-page";
import { RouteObject } from "react-router-dom";

// Token is in the URL fragment (#<token>), not the path: fragments aren't
// sent to servers, so the token never reaches CDN/server access logs, SMS
// link-preview prefetchers, or the Referer header. Do not add a `:token`
// path segment.
export const actionAuthorizeRoutes: RouteObject[] = [
  { index: true, element: <ActionAuthorizePage /> },
];
